window.NovaProject = window.NovaProject || {};

(function(Nova) {
  'use strict';

  Nova.version = '1.0.0';
  Nova.brand = 'Nova Project By Simplicity X';
  Nova.website = 'https://simplicityx.fr';

  Nova.ready = function(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  };

  Nova.ready(function() {
    document.documentElement.setAttribute('data-nova-project', 'true');
    document.dispatchEvent(new CustomEvent('nova:ready', { detail: Nova }));
  });
})(window.NovaProject);
